/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface UiRadioOption {
  id: string;
  label: string;
  detail: string;
  imageId: string;
  labelBottom: string;
}

function createBaseUiRadioOption(): UiRadioOption {
  return { id: "", label: "", detail: "", imageId: "", labelBottom: "" };
}

export const UiRadioOption = {
  encode(message: UiRadioOption, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.label !== "") {
      writer.uint32(18).string(message.label);
    }
    if (message.detail !== "") {
      writer.uint32(26).string(message.detail);
    }
    if (message.imageId !== "") {
      writer.uint32(34).string(message.imageId);
    }
    if (message.labelBottom !== "") {
      writer.uint32(58).string(message.labelBottom);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UiRadioOption {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUiRadioOption();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.label = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.detail = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.imageId = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.labelBottom = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UiRadioOption {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      detail: isSet(object.detail) ? globalThis.String(object.detail) : "",
      imageId: isSet(object.imageId) ? globalThis.String(object.imageId) : "",
      labelBottom: isSet(object.labelBottom) ? globalThis.String(object.labelBottom) : "",
    };
  },

  toJSON(message: UiRadioOption): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.detail !== "") {
      obj.detail = message.detail;
    }
    if (message.imageId !== "") {
      obj.imageId = message.imageId;
    }
    if (message.labelBottom !== "") {
      obj.labelBottom = message.labelBottom;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UiRadioOption>, I>>(base?: I): UiRadioOption {
    return UiRadioOption.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UiRadioOption>, I>>(object: I): UiRadioOption {
    const message = createBaseUiRadioOption();
    message.id = object.id ?? "";
    message.label = object.label ?? "";
    message.detail = object.detail ?? "";
    message.imageId = object.imageId ?? "";
    message.labelBottom = object.labelBottom ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
